import React from "react";
import { FormattedMessage, type MessageDescriptor } from "react-intl";
import { NavLink } from "react-router-dom";

import { Button } from "~/common/redesign-v1/ui";

export function RedesignListError({ onRetry, testId }: { onRetry: () => void; testId?: string }) {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-py-14 tw-text-center" role="alert" data-testid={testId}>
      <p className="tw-m-0 tw-text-base tw-font-semibold tw-text-foreground">
        <FormattedMessage id="error_boundary.title" />
      </p>
      <p className="tw-m-0 tw-max-w-md tw-text-sm tw-text-muted-foreground">
        <FormattedMessage id="error_boundary.message" />. <FormattedMessage id="error_boundary.message_2" />.
      </p>
      <Button variant="outline" size="sm" className="tw-mt-1 tw-rounded-rd" onClick={onRetry} data-testid={testId ? `${testId}-retry` : undefined}>
        <FormattedMessage id="general.retry" />
      </Button>
    </div>
  );
}

export function RedesignListEmpty({
  heading,
  description,
  action,
  testId,
}: {
  heading: MessageDescriptor["id"];
  description?: MessageDescriptor["id"];
  action?: { to: string; label: MessageDescriptor["id"] };
  testId?: string;
}) {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-py-14 tw-text-center" data-testid={testId}>
      <p className="tw-m-0 tw-text-base tw-font-semibold tw-text-foreground">
        <FormattedMessage id={heading} />
      </p>
      {description ? (
        <p className="tw-m-0 tw-max-w-md tw-text-sm tw-text-muted-foreground">
          <FormattedMessage id={description} />
        </p>
      ) : null}
      {action ? (
        <Button asChild variant="outline" size="sm" className="tw-mt-1 tw-rounded-rd">
          <NavLink to={action.to}>
            <FormattedMessage id={action.label} />
          </NavLink>
        </Button>
      ) : null}
    </div>
  );
}
